import { useCreditor } from '@debbie/cortex/dist/creditors/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import {
  useCreditorIntegrationActivations,
  useIntegrations,
} from '@debbie/cortex/dist/integrations/index.js'
import { useMe } from '@debbie/cortex/dist/me/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js'
import { PageBase, Panel, TopNav } from '@debbie/iris/dist/components/index.js'
import Integrations from '@debbie/iris/dist/components/integrations/Integrations.js'
import React from 'react'
import { useSelector } from 'react-redux'

type Props = {
  creditorId: string
}

const CreditorIntegrations = (props: Props) => {
  const creditorId = props.creditorId
  const meLoadable = useMe()
  const me = h.hasData(meLoadable) ? meLoadable.data : null
  const selectedTenant = useTenantId()

  const creditorActivationsLoadable =
    useCreditorIntegrationActivations(creditorId)
  const integrationListLoadable = useIntegrations()

  const creditor = useCreditor(creditorId)

  const lang = useSelector((state: RootState) => state.lang)

  if (
    !h.hasData(integrationListLoadable) ||
    !h.hasData(creditorActivationsLoadable)
  ) {
    return null
  }
  const activeActivations = creditorActivationsLoadable.data.filter(
    (integration) => integration.active,
  )

  // TODO: Possibly do this in backend
  const integrations = integrationListLoadable.data.filter((i) =>
    (me != null
      ? me.tenants
          .find((t) => t.id === selectedTenant)!
          .allowedIntegrations.includes(i.id)
      : false) && h.hasData(creditor)
      ? creditor.data.allowedIntegrations.includes(i.id)
      : false,
  )

  const installedIntegrations = integrations.filter(
    (integration) =>
      activeActivations.findIndex(
        (activation) => activation.integrationId === integration.id,
      ) !== -1,
  )

  const availableIntegrations = integrations.filter(
    (integration) =>
      activeActivations.findIndex(
        (activation) => activation.integrationId === integration.id,
      ) === -1,
  )

  return (
    <>
      <TopNav />
      <PageBase>
        <div
          style={{
            maxWidth: '1400px',
            margin: '0px auto',
          }}
        >
          <Panel header={lang.integrations.activeIntegrations}>
            <Integrations
              genLink={(i) => `/${props.creditorId}/integrations/${i.id}`}
              creditorId={creditorId}
              integrations={installedIntegrations}
            ></Integrations>
          </Panel>
          <Panel header={lang.integrations.available}>
            <Integrations
              genLink={(i) => `/${props.creditorId}/integrations/${i.id}`}
              creditorId={creditorId}
              integrations={availableIntegrations}
            ></Integrations>
          </Panel>
        </div>
      </PageBase>
    </>
  )
}

export default CreditorIntegrations
